<!-- Initializing the audio player -->
<div [class]="shakaStyleCss" id="audioContainer" #audioContainer>
    <p *ngIf="errorInPlaying">
        <!-- error message to be display on UI  -->
        {{errorMsg}}
    </p>
    <video #audioPlayer id="audioPlayer" width="100%" height="100%" [autoplay]="autoplay"></video>
</div>
